import duotone from 'icons/duotone';
import { API_ENDPOINTS } from '../../Network/apiEndpoints';
import axios from 'axios';

export const navigations = await (async () => {
  const userRole = JSON.parse(localStorage.getItem("logged_data"))?.user?.role || '';
  const chapterId = JSON.parse(localStorage.getItem("logged_data"))?.user?.chapter_id || '';
  
  // Fetch district count first
  let districtCount = '0';
  
  if (userRole === 'chapter_admin') {
    try {
      const response = await axios.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.GET_member_count_by_chapters+ `?chapter_id=${chapterId}`);
      if (response.data.success) {
        districtCount = response.data.data.member_count.toString();
      }
    } catch (error) {
      console.error('Error fetching district count:', error);
    }
  }
  else{
    try {
      const response = await axios.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.GET_district_count);
      if (response.data.success) {
        districtCount = response.data.data.district_count.toString();
      }
    } catch (error) {
      console.error('Error fetching district count:', error);
    }
  }
 
  
  const allNavigations = [
    {
      name: 'MUK Dashboard',
      path: userRole === 'chapter_admin' ? '/dashboard/members' : '/dashboard',
      icon: duotone.CommentsQuestionCheck,
      badge: {
        value: districtCount
      }
    },
    {
      name: 'Events',
      icon: duotone.DataTable,
      path: '/dashboard/events',
    },
    {
      name: 'Business Category',
      icon: duotone.LayerGroup,
      path: '/dashboard/business-category'
    },
    {
      name: 'Meeting Report',
      icon: duotone.FileCircleQuestion,
      path: '/dashboard/chapter-attendance'
    },
    {
      name: 'Self Registered Members',
      icon: duotone.UserList,
      path: '/dashboard/self-registered-members'
    }
  ];

  // Filter navigation based on user role
  if (userRole === 'super_admin') {
    return [
      allNavigations[0], // Dashboard
      allNavigations[1], // Events
      allNavigations[2], // Business Category
      allNavigations[4]  // Self Registered Members
    ];
  } else if (userRole === 'chapter_admin') {
    return [
      allNavigations[0], // Dashboard
      allNavigations[1], // Events
      allNavigations[3]  // Chapter Attendance
    ];
  }

  return []; // Return empty array if no role matched
})();